import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from './redux/actions';
import CommonPageComponent from '../../common/ui/CommonPageComponent';
import ParentContentCard from '../common/ParentContentCard';
import { ErrorMessage, Field, Formik, Form } from 'formik';
import CustomSelect from '../home/collections/CustomSelect';
import { dropdownsForSource } from '../../common/utils/data_source-util';
import CustomLoader from '../common/CustomLoader';
import {
  convertFields,
  getFieldDataTypeValue,
  prepareValidationForMysqlCollection,
} from './common/common_utils';
import FormFieldWithLabel from '../common/FormFieldWithLabel';
import CustomRadio from '../../common/ui/CustomRadio';
import AlertMessageBox from '../../common/ui/AlertMessageBox';
import { checkDataSourcePermission } from '../../common/utils/permissions';
import PermissionDenied from '../../common/PermissionDenied';
import {
  createSelectOptionsForField,
  nonExternalDBCollectionOptions,
  nonExternalDBCollections,
} from './utils';
import TooltipInfo from '../../common/docs/TooltipInfo';
import { showAlertHtml } from '../../common/utils/alert';
export class MySqlCollectionsCreate extends Component {
  static propTypes = {
    dataConnector: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };

  state = {
    selectedCollectionIndex: 0,
    fieldDatatypes: [],
    mysqlData: {},
    selectedPrimaryKey: 'id',
    isExistingCollection: false,
    collections: [],
    mappedCollection: {},
    mappedCollectionFieldOptions: [],
    mappedCollectionFields: [],
    hasExtraKey: false,
  };

  async componentDidMount() {
    const { actions, match, location } = this.props || {};
    const { params } = match || {};
    const { projectId, version, dbUuid } = params;
    let stateData = {};
    if (location.state && location.state.collectionIndex) {
      const { collectionIndex } = this.props.location.state;
      stateData['selectedCollectionIndex'] = collectionIndex;
    }
    await actions.getMySqlExternalDb({ version, projectId, dbUuid });
    const { mysqlStoredData } = this.props.dataConnector;
    console.log(
      '🚀 ~ MySqlCollectionsCreate ~ componentDidMount ~ mysqlStoredData:',
      mysqlStoredData,
    );
    if (mysqlStoredData) {
      stateData['mysqlData'] = mysqlStoredData;

      const { completeData } = mysqlStoredData;
      let fieldData;
      let selectedCollection;
      if (completeData) {
        selectedCollection = completeData
          ? completeData.tables[stateData['selectedCollectionIndex'] || 0]
          : null;
        fieldData = selectedCollection ? selectedCollection.fields : null;
        const primaryField = fieldData.find((field) => field.COLUMN_KEY === 'PRI');
        if (!selectedCollection.selectedPrimaryKey && primaryField) {
          stateData['selectedPrimaryKey'] = primaryField.COLUMN_NAME;
        } else if (selectedCollection.selectedPrimaryKey) {
          stateData['selectedPrimaryKey'] = selectedCollection.selectedPrimaryKey;
        }
        const hasExtraKey = fieldData.some((field) => field.hasOwnProperty('EXTRA'));
        console.log('🚀 ~ MySqlCollectionsCreate ~ componentDidMount ~ hasExtraKey:', hasExtraKey);
        stateData['hasExtraKey'] = hasExtraKey;
      }
    }
    await actions.loadCollections({ projectId, version });
    const { collections } = this.props.dataConnector;
    const filteredCollections = nonExternalDBCollections(collections);
    stateData['collections'] = filteredCollections;
    this.setState({ ...stateData });
  }

  checkCollectionIndex = (state) => {
    if (state) {
      if (state.collectionIndex >= 0) {
        return true;
      }
    }
    return false;
  };

  handleNextCollection = () => {
    const { match, location } = this.props;
    const { projectId, version, dbUuid } = match.params;
    const { mysqlData } = this.state;
    const { completeData } = mysqlData;
    if (this.checkCollectionIndex(location.state)) {
      this.props.history.push(
        `/data-connector/${version}/v/${projectId}/mysql-datasource/${dbUuid}/edit`,
      );
    } else {
      const { selectedCollectionIndex } = this.state;
      const newArray = completeData ? completeData.tables : [];
      const totalLengh = newArray.length - 1;
      if (selectedCollectionIndex < totalLengh) {
        this.setState({
          selectedCollectionIndex: selectedCollectionIndex + 1,
          selectedPrimaryKey: '',
        });
      } else {
        this.props.history.push(`/collections/${version}/v/${projectId}`);
      }
    }
  };

  handleSave = async (values) => {
    const {
      selectedCollectionIndex,
      fieldDatatypes,
      mysqlData,
      selectedPrimaryKey,
      isExistingCollection,
      mappedCollection,
      mappedCollectionFields,
    } = this.state;
    const { actions, match } = this.props;
    const { completeData, setting, name } = mysqlData;
    const newArray = completeData ? completeData.tables : [];
    const selectedData = newArray[selectedCollectionIndex];
    const fieldData = selectedData.fields;
    let formattedFieldData = {};
    if (fieldData && fieldData.length) {
      formattedFieldData = fieldData.reduce((acc, field) => {
        acc[field.COLUMN_NAME] = field.DATA_TYPE;
        return acc;
      }, {});
    }

    let result = {};
    Object.keys(formattedFieldData).map((fieldName, index) => {
      result[fieldName] = fieldDatatypes[fieldName]
        ? fieldDatatypes[fieldName].value
        : formattedFieldData[fieldName];
    });

    if (Object.keys(result) && Object.keys(result).length) {
      result = convertFields(result);
    }

    const { projectId, dbUuid, version } = match.params;
    const data = {
      version,
      projectId,
      collectionName: isExistingCollection ? mappedCollection.collectionName : selectedData.name,
      collectionTitle: isExistingCollection
        ? mappedCollection.collectionTitle
        : values.collectionTitle,
      orgCollectionName: selectedData.name,
      willPersist: false,
      fields: result,
      databaseUrl: completeData && completeData['database'],
      setting,
      externalDatabaseId: dbUuid,
      selectedPrimaryKey: selectedPrimaryKey ? selectedPrimaryKey : 'id',
      name: name ? name : '',
      tableIndex: selectedCollectionIndex,
      mysqlFields: fieldData,
      isExistingCollection,
      mappedCollectionId: isExistingCollection ? mappedCollection.uuid : null,
      mappedCollectionName: isExistingCollection ? mappedCollection.collectionName : null,
      mappedCollectionFields: isExistingCollection ? mappedCollectionFields : null,
    };
    await actions.updateMySqlExternalDb(data);
    if (isExistingCollection) {
      await actions.mapCollectionWithMySql(data);
    } else {
      await actions.createCollectionWithMySql(data);
    }
    this.handleNextCollection();
  };

  handleFieldTypeChange = (fieldName, selectedValue) => {
    const updatedResult = { ...this.state.fieldDatatypes };
    updatedResult[fieldName[0]] = selectedValue;
    this.setState({ fieldDatatypes: updatedResult });
  };

  handleFieldChange = (fieldName, selectedValue) => {
    const updatedResult = { ...this.state.mappedCollectionFields };
    updatedResult[fieldName[0]] = selectedValue;
    this.setState({ mappedCollectionFields: updatedResult });
  };

  getMappedField = (fieldName) => {
    const { mappedCollectionFields, mappedCollectionFieldOptions } = this.state;
    if (mappedCollectionFields && mappedCollectionFields[fieldName]) {
      return mappedCollectionFields[fieldName];
    } else if (mappedCollectionFieldOptions && mappedCollectionFieldOptions[fieldName]) {
      return mappedCollectionFieldOptions[fieldName];
    }
    return '';
  };

  handlePrimaryKeyChange = (fieldName) => {
    this.setState({ selectedPrimaryKey: fieldName });
  };

  handleCheckboxChange = (event) => {
    const { name, checked } = event.target;

    const confirmationMsg = checked
      ? `<div style="text-align: left;">Enable it to map the MySQL table with an existing collection in DrapCode.</div><br/><br/>
     <ol class="px-3" style="text-align: left;font-size: 14px;">
     <li class="mb-2">The selected collection will be mapped with the Datasource which is irreversible.</li>
     <li class="mb-2">The selected collection will be converted to the Non-persistent collection.</li>
     <li class="mb-2">You'll have to map the MySQL fields with the Collection fields in the Collection Field Mapping section below.</li>
     </ol>
     <p style="text-align: left;">
      <b>Please note:</b> Once the collection is mapped, it cannot be unmapped later.
     </p>
      <br/>Are you sure you want to proceed?`
      : `<div style="text-align: left;">This will remove the mapped collection and allow you to create a new collection based on the MySQL table.</div><br/>
      <p style="text-align: left;">
      <b>Please note:</b> Once unmapped, the previous mapping cannot be restored.
     </p>
      <br/>Are you sure you want to proceed?`;

    const preConfirm = () => {
      this.setState({
        [name]: checked,
      });
    };

    showAlertHtml(confirmationMsg, preConfirm, 'Proceed');
  };

  handleCollectionChange = (selectedOption) => {
    const { value } = selectedOption || {};
    const { collections } = this.state;
    let collection = {};
    let collectionFieldOptions = [];
    if (value) {
      collection = collections.find((coll) => coll.collectionName === value);
      const { fields } = collection || {};
      collectionFieldOptions = createSelectOptionsForField(fields);
    }
    this.setState({
      mappedCollection: collection,
      mappedCollectionFieldOptions: collectionFieldOptions,
    });
  };

  showAlertMessage = () => {
    return (
      <AlertMessageBox
        type="info"
        text={`Note: If no primary key is selected below, the system will default to using the 
<strong>'id'</strong> field as the primary key for External APIs.`}
      />
    );
  };

  primaryKey = (field, fields) => {
    const { selectedPrimaryKey } = this.state;
    if (selectedPrimaryKey) {
      return selectedPrimaryKey === field.COLUMN_NAME;
    } else {
      const primaryField = fields.find((field) => field.COLUMN_KEY === 'PRI');
      return primaryField && field.COLUMN_NAME === primaryField.COLUMN_NAME;
    }
  };

  autoIncrement = (field, fields) => {
    const autoIncrementField = fields.find((field) => field.EXTRA === 'auto_increment');
    return autoIncrementField && field.COLUMN_NAME === autoIncrementField.COLUMN_NAME;
  };

  render() {
    const isAllowed = checkDataSourcePermission();
    if (!isAllowed) {
      return (
        <CommonPageComponent>
          <PermissionDenied message="Data Source" />
        </CommonPageComponent>
      );
    }
    const {
      mysqlData,
      selectedCollectionIndex,
      collections,
      isExistingCollection,
      mappedCollectionFieldOptions,
      hasExtraKey,
    } = this.state;
    const { getMySqlExternalDbPending, createCollectionWithMySqlPending } =
      this.props.dataConnector;
    const { completeData } = mysqlData;
    let fieldData;
    let selectedCollection;
    let formattedFieldData = {};
    if (completeData) {
      selectedCollection = completeData ? completeData.tables[selectedCollectionIndex] : null;
      fieldData = selectedCollection ? selectedCollection.fields : null;

      if (fieldData && fieldData.length) {
        formattedFieldData = fieldData.reduce((acc, field) => {
          acc[field.COLUMN_NAME] = field.DATA_TYPE;
          return acc;
        }, {});
      }
    }
    return fieldData ? (
      <CommonPageComponent>
        <ParentContentCard
          title={'Choose Collection for Create Or Skip via MySQL'}
          icon={'collection'}
        >
          <Formik
            initialValues={{
              collectionTitle: selectedCollection.name,
              collectionName: null,
            }}
            enableReinitialize={true}
            validationSchema={prepareValidationForMysqlCollection(isExistingCollection)}
            onSubmit={this.handleSave}
          >
            {({ isSubmitting, values, setFieldValue, setFieldTouched }) => (
              <Form className="ml-5">
                <div className="col-md-12 col-lg-11 col-sm-12 col-xs-12">
                  <div className="form-group">
                    <FormFieldWithLabel
                      cta={false}
                      label="Collection Name (MySQL Table)"
                      icon="text"
                      infoIcon={true}
                      infoDescription={
                        'MySQL table name based on which the collection with the displayed Collection Name will be created in DrapCode'
                      }
                    >
                      <Field
                        type="text"
                        className="form-control form-control-sm"
                        placeholder="Collection Name"
                        readOnly
                        disabled
                        value={selectedCollection.name}
                      />
                    </FormFieldWithLabel>
                  </div>
                  {isExistingCollection ? (
                    <div className="form-group">
                      <FormFieldWithLabel
                        cta={false}
                        label="Existing Collection"
                        icon="select"
                        infoIcon={true}
                        infoDescription={
                          'Select an existing collection which you want to map with the MySQL table.'
                        }
                      >
                        <CustomSelect
                          name="collectionName"
                          placeholder={'Select Collection for mapping'}
                          isMulti={false}
                          value={values.collectionName}
                          options={nonExternalDBCollectionOptions(collections)}
                          onChange={setFieldValue}
                          onBlur={setFieldTouched}
                          onChangeValue={(name, value) => this.handleCollectionChange(value)}
                        />
                        <ErrorMessage name="collectionName" component="p" className="text-danger" />
                      </FormFieldWithLabel>
                    </div>
                  ) : (
                    <div className="form-group">
                      <FormFieldWithLabel
                        cta={false}
                        label="Collection Title"
                        icon="text"
                        infoIcon={true}
                        infoDescription={'Enter name for the Collection Name if you want to change'}
                      >
                        <Field
                          type="text"
                          name="collectionTitle"
                          className="form-control form-control-sm"
                          placeholder="Collection Title"
                          value={values.collectionTitle}
                          onChange={(e) => setFieldValue('collectionTitle', e.target.value)}
                        />

                        <ErrorMessage
                          name="collectionTitle"
                          component="p"
                          className="text-danger"
                        />
                      </FormFieldWithLabel>
                    </div>
                  )}
                  <div className="form-group">
                    <div className="col-12">
                      <div className="input-group" title="Map with existing collection">
                        <div className="input-group-prepend">
                          <span className="input-group-text">
                            <i className="wb webconnect-toggles"></i>
                          </span>
                        </div>
                        <div className="form-check">
                          <CustomRadio label="Map with existing collection" isRadio={false}>
                            <input
                              name="isExistingCollection"
                              type="checkbox"
                              className="form-check-input"
                              checked={isExistingCollection}
                              onChange={this.handleCheckboxChange}
                            />
                          </CustomRadio>
                        </div>
                        <TooltipInfo
                          title={'Map the MySQL table with the existing collection'}
                          headerText={`What's Map with existing Collection?`}
                          showHeader={true}
                          showArrow={true}
                          append={true}
                        />
                      </div>
                    </div>
                  </div>
                  <hr style={{ marginBottom: '20px', visibility: 'hidden' }} />
                  {this.showAlertMessage()}
                  <div className="mt-2">
                    <h5>
                      <b>
                        {isExistingCollection ? 'Collection Field Mapping' : 'Field Type Mapping'}
                      </b>
                    </h5>
                  </div>
                  <div
                    className="table-responsive"
                    style={{
                      overflow: 'visible',
                      maxHeight: 'fit-content',
                      marginBottom: '10px',
                    }}
                  >
                    <table className="table table-bordered">
                      <thead>
                        <tr>
                          <th>MySQL Fields</th>
                          <th>MySQL Fields Type</th>
                          <th>
                            {isExistingCollection ? 'Collection Field' : 'DrapCode Field Types'}
                          </th>
                          <th style={{ width: '12%' }}>Primary Key</th>
                          {hasExtraKey && <th style={{ width: '12%' }}>AutoIncremented</th>}
                        </tr>
                      </thead>
                      <tbody>
                        {fieldData.map((field, index) => (
                          <tr key={index}>
                            <td>{field.COLUMN_NAME}</td>
                            <td>{field.DATA_TYPE}</td>
                            <td>
                              {isExistingCollection && this.state.mappedCollection ? (
                                <CustomSelect
                                  name={field.COLUMN_NAME}
                                  placeholder={'Select Field for mapping'}
                                  isMulti={false}
                                  onChange={setFieldValue}
                                  onChangeValue={this.handleFieldChange}
                                  options={mappedCollectionFieldOptions}
                                  value={this.getMappedField(field.COLUMN_NAME)}
                                />
                              ) : (
                                <CustomSelect
                                  name={field.COLUMN_NAME}
                                  isMulti={false}
                                  onChange={setFieldValue}
                                  onChangeValue={this.handleFieldTypeChange}
                                  options={dropdownsForSource}
                                  value={getFieldDataTypeValue(
                                    field.COLUMN_NAME,
                                    formattedFieldData,
                                    this.state.fieldDatatypes,
                                  )}
                                />
                              )}
                            </td>
                            <td style={{ width: '12%' }}>
                              <div className="form-check ml-4 pl-3">
                                <CustomRadio label="" isRadio={false}>
                                  <Field
                                    type="checkbox"
                                    name={field.COLUMN_NAME}
                                    className="form-check-input"
                                    checked={this.primaryKey(field, fieldData)}
                                    onChange={() => this.handlePrimaryKeyChange(field.COLUMN_NAME)}
                                  />
                                </CustomRadio>
                              </div>
                            </td>
                            {hasExtraKey && (
                              <td style={{ width: '12%' }}>
                                <div className="form-check ml-4 pl-3">
                                  <CustomRadio
                                    label=""
                                    isRadio={false}
                                    extraClass="disabled-checkbox no-pointer-events"
                                  >
                                    <Field
                                      type="checkbox"
                                      name={field.COLUMN_NAME}
                                      className="form-check-input"
                                      checked={this.autoIncrement(field, fieldData)}
                                      disabled={true}
                                    />
                                  </CustomRadio>
                                </div>
                              </td>
                            )}
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                  <div className="d-flex justify-content-between">
                    <button
                      className="btn btn-outline-secondary btn-md"
                      title="Skip"
                      type="button"
                      onClick={this.handleNextCollection}
                    >
                      <i className="wb webconnect-times"></i> Skip & Continue
                    </button>
                    <button
                      type="submit"
                      className="btn btn-theme-submit btn-md ml-3"
                      title="Save Collection"
                      disabled={isSubmitting || createCollectionWithMySqlPending}
                    >
                      <i className="wb webconnect-save-regular"></i> Save & Continue
                      <CustomLoader loading={createCollectionWithMySqlPending} />
                    </button>
                  </div>
                </div>
              </Form>
            )}
          </Formik>
        </ParentContentCard>
      </CommonPageComponent>
    ) : (
      <CommonPageComponent>
        <div className="text-center">
          <CustomLoader loading={getMySqlExternalDbPending} size="20px" color="#303453" />
        </div>
      </CommonPageComponent>
    );
  }
}

function mapStateToProps(state) {
  return {
    dataConnector: state.dataConnector,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(MySqlCollectionsCreate);
